module.exports = __webpack_public_path__ + "img/homeLogin.d44899e7.png";